
<div class="buy_icon">
	<a routerLink="/sell" class="text-white btn shadow-lg">
    <div class="row">
		<div class="col-lg-1">
		  <img src="./assets/image/icon/Purchase.png">
		</div>
		<div class="col-lg-3 text-white">
		  Buy
		</div>
  </div>
	</a> 
</div> 

<div class="sell_icon">
	<a routerLink="/sell" class="text-white btn shadow-lg">
    <div class="row">
		<div class="col-lg-1">
		  <img src="./assets/image/icon/Sell.png">
		</div>
		<div class="col-lg-3 text-white">
		  Sell
		</div>
  </div>
	</a>                                    
</div> 
